import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { content } from 'src/environments/data';

@Injectable({
  providedIn: 'root'
})
export class ObservableCookieService {
  private cookieSubject: BehaviorSubject<{[key: string]: string}> = new BehaviorSubject({});

  constructor(private cookieService: CookieService) {
    this.updateCookieSubject();
  }

  private updateCookieSubject(): void {
//    const cookieObject: {[key: string]: string} = {};
    const cookieObject = this.cookieService.getAll();

    this.cookieSubject.next(cookieObject);
  }

  getCookie(key: string): string {
    return this.cookieService.get(key);
  }

  setCookie(key: string, value: string, date: Date): void {
    // Drop legacy cookies scoped to /login (default path when Path was omitted).
    const loginPath = '/' + content.WEBDDN_LOGIN_PATH.replace(/^\//, '');
    this.cookieService.delete(key, loginPath);
    this.cookieService.set(key, value, date, '/');
    this.updateCookieSubject();
  }

  deleteCookie(key: string): void {
    const loginPath = '/' + content.WEBDDN_LOGIN_PATH.replace(/^\//, '');
    this.cookieService.delete(key, loginPath);
    this.cookieService.delete(key, '/');
    this.updateCookieSubject();
  }

  getCookieObservable(): Observable<{[key: string]: string}> {
    return this.cookieSubject.asObservable();
  }
}